import React, { Component } from 'react'
import { selectMode } from '../../../actions/commonActions'
import { connect } from 'react-redux'
export class AboutRecurring extends Component { 
  componentDidMount() {
    this.props.selectMode('integration_guide')
  }

    render() {
      return (
          <div className="stepPageContainer">  
            <h3 className="stepPageTitle">About Recurring Billing</h3>
            <p>Recurring Billing allows you to set up payments whereby Moneris automatically processes the trans- actions and bills customers on your behalf based on the billing cycle information you provide.</p>
            <p>Recurring Billing series are created by sending the Recurring Billing object in these transactions:</p>
            <ol>
              <li>Purchase</li>
              <li>PurchasewithVault</li>
              <li>Purchasewith3-DSecure(cavvPurchase)</li>
            </ol>

            <p>You can modify a Recurring Billing series after it has been created by sending the Recurring Billing Update administrative transaction.</p>
            <p className="thingsToConsider">
              <strong>NOTE: </strong> 
              Alternatively, if you prefer to manage recurring series on your own merchant system,
              you can send the periodic payments as basic Purchase transactions with the e-commerce
              indicator (<code>crypt_type</code>) value = 2 and with the Credential on File info object
              included.         
            </p>
          </div>
        )
    }
}



const mapStateToProps = state => {
  const {mode} = state.common.sideNav;
  return { mode};
}

export default connect(mapStateToProps, { selectMode})(AboutRecurring)

